<div *ngFor="let row of gridRows">
  <div *ngFor="let element of row.elements; trackBy: trackByIndex;"
       #LMGridElement
       [attr.colIndex]="element.colIndex"
       [class]="element.class">
    <ng-template
        visiblewhen
        [layoutObject]="getLayoutObject(element)"
        [model]="model"
        [specFields]="specFields"
    >
      <ng-template [ngIf]="element.field">
        <lm-field *ngIf="!element.field.cfgHidden"
            [layoutObject]="element.field"
            [layoutInfo]="layoutInfo"
            [lmColumnLayoutInfo]="lmColumnLayoutInfo"
            [specFields]="specFields"
            [placeHolder]="placeHolder"
            [model]="model"
            (fieldEvent)="onFieldEvent($event)"
        ></lm-field>
      </ng-template>

      <ng-template [ngIf]="element.checkcontrol">
        <lm-checkcontrol *ngIf="!element.checkcontrol.cfgHidden"
            [layoutObject]="element.checkcontrol"
            [layoutInfo]="layoutInfo"
            [specFields]="specFields"
            [placeHolder]="placeHolder"
            [model]="model"
            (fieldEvent)="onFieldEvent($event)"
        ></lm-checkcontrol>
      </ng-template>

      <ng-template [ngIf]="element.captchaControl">
        <lm-captcha-control [layoutObject]="element.captchaControl"></lm-captcha-control>
      </ng-template>

      <ng-template [ngIf]="element.header">
        <lm-header
            [layoutObject]="element.header"
            [layoutInfo]="layoutInfo"
            [specFields]="specFields"
            [model]="model"
        ></lm-header>
      </ng-template>

      <ng-template [ngIf]="element.paragraph">
        <lm-paragraph
            [layoutObject]="element.paragraph"
            [layoutInfo]="layoutInfo"
            [lmColumnLayoutInfo]="lmColumnLayoutInfo"
            [specFields]="specFields"
            [placeHolder]="placeHolder"
            [model]="model"
            (fieldEvent)="onFieldEvent($event)"
        ></lm-paragraph>
      </ng-template>

      <ng-template [ngIf]="element.button">
        <lm-button *ngIf="!element.button.cfgHidden"
            [layoutObject]="element.button"
            [layoutInfo]="layoutInfo"
            [lmColumnLayoutInfo]="lmColumnLayoutInfo"
            [specFields]="specFields"
            [model]="model"
            (fieldEvent)="onFieldEvent($event)"
        ></lm-button>
      </ng-template>

      <ng-container *ngIf="element.Blank">
        <div *ngIf="lmColumnLayoutInfo" lm-blankline></div>
        <div *ngIf="!lmColumnLayoutInfo" lm-blankline></div>
      </ng-container>

      <ng-template [ngIf]="element.text">
        <lm-text
            [layoutObject]="element.text"
            [layoutInfo]="layoutInfo"
            [lmColumnLayoutInfo]="lmColumnLayoutInfo"
            [specFields]="specFields"
            [placeHolder]="placeHolder"
            [model]="model"
            (fieldEvent)="onFieldEvent($event)"
        ></lm-text>
      </ng-template>

<!--      <ng-template [ngIf]="element.menu">-->
<!--        <lm-simple-card-->
<!--            [type]="'menu'"-->
<!--            [specFields]="specFields"-->
<!--            [model]="model"-->
<!--            [scale]="element.menu.menuScale"-->
<!--            [link]="element.menu.link"-->
<!--            [showBackground]="false"-->
<!--            [imageUrl] = "element.menu.image"-->
<!--            [title]="element.menu.label"-->
<!--            [description]="element.menu.description"-->
<!--            [paragraphLayout]="false"-->
<!--            [isLink]="element.menu.isLink"-->
<!--            [isExternalLink]="element.menu.external"-->
<!--            (fieldEvent)="onFieldEvent($event)"-->
<!--        ></lm-simple-card>-->
<!--      </ng-template>-->
    </ng-template>
  </div>
</div>

